import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  backButton: {
    backgroundColor: "white",
    borderColor: colors.primary,
    borderRadius: 10,
    borderWidth: 3,
    padding: 10,
    textAlign: "center",
  },
  buttonContainer: { alignItems: "center", flex: 1, justifyContent: "flex-end", marginBottom: 30 },
  cell: {
    alignSelf: "center",
    borderColor: colors.inputFieldBorder,
    borderRadius: 10,
    borderWidth: 1,
    fontSize: 30,
    height: 60,
    justifyContent: "center",
    marginRight: 20,
    paddingTop: 5,
    textAlign: "center",
    width: 60,
  },
  container: { height: "100%", padding: 10 },
  disabledButton: {
    opacity: 0.5,
  },
  focusCell: {
    borderColor: colors.linearFirstColor,
  },
  loginButton: { marginBottom: 20 },
  loginButton2: { backgroundColor: "transparent", marginBottom: 20 },
  mb40: { marginBottom: 40 },
  modalButton: {
    color: colors.primary,
  },
  otpContainer: {
    alignItems: "center",
    justifyContent: "flex-start",
    marginVertical: 20,
    width: "100%",
  },
  phoneNumberInputContainer: { alignSelf: "center", marginTop: 0 },
  phoneNumberInputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  resentContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  rootStyle: { justifyContent: "flex-start", marginBottom: 10 },
  subtitleText: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginBottom: 30,
    marginTop: 40,
  },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    marginBottom: 30,
    marginTop: 40,
  },
})
